import { render, staticRenderFns } from "./TunnelCtrView.vue?vue&type=template&id=eb567c90&"
import script from "./TunnelCtrView.vue?vue&type=script&lang=ts&"
export * from "./TunnelCtrView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports